<template lang="pug">
  b-input-group(size="sm")
    date-picker(
      v-model="dateRange"
      :range="range"
      :value-type="type"
      lang="zh-tw"
      :format="format"
      :minute-step="minuteStep"
      append-to-body=false
      :placeholder="placeholder"
      @input="handleInput"
      :clearable="false"
      :editable="false"
      :disabled-date="notAfterDate"
      @input-error="handleInputError"
    )
    //- :not-before="$moment($moment(value[1]).subtract(14, 'days').toDate()).format('YYYY-MM-DD')"
    //- :not-before="$moment($moment().startOf('day').subtract(45, 'days').toDate()).format('YYYY-MM-DD')"
    //- :not-after="$moment().format('YYYY-MM-DD')"
</template>
<script>
import 'vue2-datepicker/index.css'

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "format"
    },
    range: {
      type: Boolean,
      default: true
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    value: {
      type: Array,
      default: null
    },
    isDisableDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dateRange: this.value,
      first: null
    };
  },
  computed: {
    shortcuts() {
      return [
        {
          text: this.$t("ui.today"),
          onClick: () => { this.shortcutsClick("today"); }
        },
        {
          text: this.$t("ui.yesterday"),
          onClick: () => { this.shortcutsClick("yesterday"); }
        },
        {
          text: this.$t("ui.thisweek"),
          onClick: () => { this.shortcutsClick("thisweek"); }
        },
        {
          text: this.$t("ui.lastweek"),
          onClick: () => { this.shortcutsClick("lastweek"); }
        }
      ];
    }
  },
  methods: {
    handleInputError (text) {
      // console.log(text)
      // clear the value
      this.value = ''
      // if you want to update value even if it's invalid
      // this.value = text
    },
    notAfterDate: function(date) {
      let notAfterToday = date > new Date (this.$moment().format('YYYY-MM-DD')).setHours(0,0,0,0)
      let notBefore180Days = date < new Date (this.$moment(this.$moment().subtract(180, 'days').toDate()).format('YYYY-MM-DD')).setHours(0,0,0,0)
      // let condition3 = date > new Date (this.$moment(this.$moment(this.dateRange[0]).add(30, 'days').toDate()).format('YYYY-MM-DD')).setHours(0,0,0,0)
      if (this.isDisableDate)
        return notAfterToday || notBefore180Days;
      else
        return false
    },
    dateDifference: function() {
      // let first = new Date (this.$moment().format('YYYY-MM-DD')).setHours(0,0,0,0)
      // let second = new Date (this.$moment(this.$moment().startOf('day').subtract(30, 'days').toDate()).format('YYYY-MM-DD')).setHours(0,0,0,0)
      let first = new Date (this.dateRange[0])
      let second = new Date (this.dateRange[1])
      return Math.round((first-second)/(1000*60*60*24))
    },
    handleInput: function(currentValue) {
      this.$store.dispatch("layout/setDateRange", this.dateRange)
      this.$emit("input", currentValue)
    },
    shortcutsClick: function(clickedShortcut) {
      switch (clickedShortcut) {
        case "today":
          this.dateRange = [
            this.$moment().startOf("day").toDate(),
            this.$moment().endOf("day").toDate()
          ];
          break;
        case "yesterday":
          this.dateRange = [
            this.$moment().startOf("day").subtract(1, "days").toDate(),
            this.$moment().endOf("day").subtract(1, "days").toDate()
          ];
          break;
        case "thisweek":
          this.dateRange = [
            this.$moment().startOf("isoweek").toDate(),
            this.$moment().endOf("isoweek").toDate()
          ];
          break;
        case "lastweek":
          this.dateRange = [
            this.$moment().startOf("isoweek").subtract(1, "weeks").toDate(),
            this.$moment().endOf("isoweek").subtract(1, "weeks").toDate()
          ];
          break;
        case "thismonth":
          this.dateRange = [
            this.$moment().startOf("month").toDate(),
            this.$moment().endOf("month").toDate()
          ];
          break;
        case "lastmonth":
          this.dateRange = [
            this.$moment().startOf("month").subtract(1, "month").toDate(),
            this.$moment().endOf("month").subtract(1, "month").toDate()
          ];
          break;
        case "last3month":
          this.dateRange = [
            this.$moment().startOf("month").subtract(3, "month").toDate(),
            this.$moment().endOf("month").subtract(1, "month").toDate()
          ];
          break;
        default:
          break;
      }

      this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$emit("input", this.dateRange);
    }
  }
};
</script>